import network from './network';
import mock from './mock';

const isMocked = process.env.REACT_APP_IS_MOCKED === 'true';

export default isMocked ? mock : { ...mock, ...network };
